import * as GeneralRepository from "./general-repository";
import * as RequisitoProvider from "../providers/requisito-provider";

export const obtenerRequisitos = async (idSolicitudMultiple) => {
    const response = await RequisitoProvider.obtenerRequisitos(idSolicitudMultiple)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            requisitos: response.entity.datos
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await obtenerRequisitos(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    requisitos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                requisitos: null
            }
        }
    }
}

export const obtenerDepartamentos = async () => {
    let parametros = [
        { campo: 'departamento', valor: 0 }
    ]

    const response = await RequisitoProvider.obtenerListaUbicacion(parametros)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            departamentos: response.entity.data
        }
    } else {
        if (response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken !== null && responseToken.error === null) {
                return await obtenerDepartamentos()
            } else {
                return {
                    error: response.auditResponse,
                    departamentos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                departamentos: null
            }
        }
    }
}

export const obtenerProvincias = async (codDepartamento) => {
    let parametros = [
        { campo: 'departamento', valor: codDepartamento },
        { campo: 'provincia', valor: 0 }
    ]

    const response = await RequisitoProvider.obtenerListaUbicacion(parametros)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            provincias: response.entity.data
        }
    } else {
        if (response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken !== null && responseToken.error === null) {
                return await obtenerProvincias(codDepartamento)
            } else {
                return {
                    error: response.auditResponse,
                    provincias: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                provincias: null
            }
        }
    }
}

export const obtenerCentrosMedicos = async (codDepartamento, codProvincia) => {
    let parametros = [
        { campo: 'departamento', valor: codDepartamento },
        { campo: 'provincia', valor: codProvincia }
    ]

    const response = await RequisitoProvider.obtenerCentrosMedicos(parametros)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            centros: response.entity.data
        }
    } else {
        if (response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await obtenerCentrosMedicos(codDepartamento, codProvincia)
            } else {
                return {
                    error: response.auditResponse,
                    centros: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                centros: null
            }
        }
    }
}

export const registrarAgendaCita = async (idSolicitudMultiple, request) => {
    const response = await RequisitoProvider.registrarAgendaCita(idSolicitudMultiple, request)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null
        }
    } else {
        if (response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await registrarAgendaCita(idSolicitudMultiple, request)
            } else {
                return {
                    error: response.auditResponse
                }
            }
        } else {
            return {
                error: response.auditResponse
            }
        }
    }
}

export const obtenerRequisitoScore = async (paths, params, headers) => {
    let atributos = [
        { campo: 'codIntermediario', valor: paths.codigoIntermediario },
        { campo: 'codAgencia', valor: paths.codigoAgencia },
        { campo: 'lineaNegocio', valor: paths.lineaNegocio },
        { campo: 'tipoDoc', valor: paths.tipoDocumento },
        { campo: 'numDoc', valor: paths.numeroDocumento }
    ]

    let parametros = [
        { campo: 'cantidadBeneficiarios', valor: params.cantidadBeneficiarios },
        { campo: 'primaTotal', valor: params.primaTotal },
        { campo: 'fechaNacimiento', valor: params.fechaNacimiento },
        { campo: 'tieneConyuge', valor: params.tieneConyuge },
        { campo: 'primaTarget', valor: params.primaTarget },
        { campo: 'frecuenciaPago', valor: params.frecuenciaPago },
        { campo: 'tipoCobranza', valor: params.tipoCobranza }
    ]

    const response = await RequisitoProvider.obtenerRequisitoScore(atributos, parametros, headers)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            score: response.entity.requisitos
        }
    } else {
        return {
            error: response.auditResponse,
            score: null
        }
        /*if (response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await obtenerRequisitoScore(paths, params)
            } else {
                return {
                    error: response.auditResponse,
                    score: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                score: null
            }
        }*/
    }
}

export const registrarRequisitoScore = async (request) => {
    const response = await RequisitoProvider.registrarRequisitosScore(request)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            ok: true
        }
    } else {
        if (response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await registrarRequisitoScore(request)
            } else {
                return {
                    error: response.auditResponse
                }
            }
        } else {
            return {
                error: response.auditResponse
            }
        }
    }
}

export const obtenerRequisitosAdicional = async (idSolicitudMultiple) => {
    const response = await RequisitoProvider.obtenerRequisitosAdicional(idSolicitudMultiple)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            requisitos: response.entity.datos
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await obtenerRequisitosAdicional(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    requisitos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                requisitos: null
            }
        }
    }
}

export const registrarAgendaCitaAdicional = async (idSolicitudMultiple, request) => {
    const response = await RequisitoProvider.registrarAgendaCitaAdicional(idSolicitudMultiple, request)
    if (response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null
        }
    } else {
        if (response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if (responseToken.error === null) {
                return await registrarAgendaCitaAdicional(idSolicitudMultiple, request)
            } else {
                return {
                    error: response.auditResponse
                }
            }
        } else {
            return {
                error: response.auditResponse
            }
        }
    }
}
